<template>
    <transition name="sticky">
        <button-target
            v-if="show"
            class="card-sticky-mobile"
            background="orange"
            size="md"
            :link="document"
        />
    </transition>
</template>

<script>
export default {
    props: {
        document: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    data() {
        return {
            show: false
        };
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.scroll);
    },
    mounted() {
        this.scroll();
        window.addEventListener('scroll', this.scroll);
    },
    methods: {
        scroll() {
            if (window.scrollY >= 700) {
                this.show = true; 
            }
            else {
                this.show = false; 
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.card-sticky-mobile {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    z-index: 1;
    box-shadow: $bxs;

    ::v-deep a {
        box-shadow: none;
        border-radius: 0;
    }

    @media screen and (min-width: 1000px) {
        display: none;
    }
}

.sticky-enter-active,
.sticky-leave-active {
    transition: all .3s;
}
.sticky-enter,
.sticky-leave-to {
    transform: translateY(-100px);
}
</style>
